import $ from 'jquery';

import Accordion from '../utils/Accordion';

export default class NavMobileSubMenus {
  constructor($el) {
    this.$el = $el;

    this.Accordion = new Accordion(this.$el, {
      activeClass: 'visible',
      content: '[data-accordion-content]',
    });

    // Sub menu selectors
    this.activeMenuClass = 'navmenu-link-parent-active';
    this.expandedItemClass = 'navmenu-item-expanded';
    this.activeMenu = `.${this.activeMenuClass}`;

    this.navTrigger = '[data-navmenu-trigger]';
    this.subMenu = '[data-navmenu-submenu]';
    this.navMenu = '[data-navmenu]';
    this._bindEvents();
  }

  unload() {
    this.$el.off('.mobile-nav');

    delete this.Accordion;
  }

  closeSubMenus($current) {
    $current.find(this.activeMenu).each((index, el) => {
      this._closeSubmenu($(this.navTrigger, el));
    });
  }

  closeAllSubmenus() {
    this.Accordion.closeOpen();
  }

  _bindEvents() {
    // Prevent focus state from applying on mouse click
    this.$el.on('mousedown.mobile-nav', '.navmenu-link', (event) => {
      event.preventDefault();
    });

    this.$el.on('click.mobile-nav', this.navTrigger, (event) => {
      event.preventDefault();
      this._toggleSubmenu(event);
    });
  }

  _selectSubMenu($target) {
    return $target.parent().next(this.subMenu);
  }

  _toggleSubmenu(event) {
    const $target = $(event.currentTarget);

    if ($target.parent().hasClass(this.activeMenuClass)) {
      this._closeSubmenu($target);
    } else {
      this._openSubmenu($target);
    }
  }

  _openSubmenu($target) {
    this.closeSubMenus($target.closest(this.navMenu));

    const $menu = this._selectSubMenu($target);

    $target
      .parent()
      .addClass(this.activeMenuClass)
      .attr('aria-expanded', true);

    $target
      .parents('.navmenu-item')
      .first()
      .addClass(this.expandedItemClass);

    this.Accordion.toggle($menu);
  }

  _closeSubmenu($target) {
    const $menu = this._selectSubMenu($target);
    $target
      .parent()
      .removeClass(this.activeMenuClass)
      .attr('aria-expanded', false);

    const $parentElement = $target.parents('.navmenu-item').first();
    $parentElement.removeClass(this.expandedItemClass);

    this.Accordion.toggle($menu);

    const $openChild = $(this.activeMenu, $parentElement);
    if ($openChild.length) {
      this._closeSubmenu($(this.navTrigger, $openChild));
    }
  }
}
